import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Phone, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navigation = [
    { name: "Home", path: "/" },
    { name: "Properties", path: "/properties" },
    { name: "About", path: "/about" },
    { name: "Service Areas", path: "/service-areas" },
    { name: "FAQ", path: "/faq" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <header className="bg-white border-b border-border sticky top-0 z-50" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center" data-testid="logo-link">
            <span className="text-2xl md:text-3xl font-heading font-bold text-primary">
              MURRAY
            </span>
            <span className="text-2xl md:text-3xl font-heading font-light text-accent ml-2">
              REALTOR
            </span>
          </Link>

          <nav className="hidden lg:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="text-sm uppercase tracking-widest font-semibold text-foreground hover:text-accent transition-colors duration-300"
                data-testid={`nav-${item.name.toLowerCase().replace(' ', '-')}`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:4168278717" className="flex items-center text-sm text-muted-foreground hover:text-accent transition-colors" data-testid="header-phone">
              <Phone className="w-4 h-4 mr-2" />
              (416) 827-8717
            </a>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2"
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="lg:hidden bg-white border-t border-border" data-testid="mobile-menu">
          <nav className="px-6 py-4 space-y-4">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="block text-sm uppercase tracking-widest font-semibold text-foreground hover:text-accent transition-colors"
                onClick={() => setIsOpen(false)}
                data-testid={`mobile-nav-${item.name.toLowerCase().replace(' ', '-')}`}
              >
                {item.name}
              </Link>
            ))}
            <div className="pt-4 border-t border-border">
              <a href="tel:4168278717" className="flex items-center text-sm text-muted-foreground" data-testid="mobile-phone">
                <Phone className="w-4 h-4 mr-2" />
                (416) 827-8717
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
